"use client";

import { createContext, useContext } from "react";

export type CompanionHostContextValue = {
  hostApiBaseUrl?: string;
  /** Passed to signup as `siteId` for Store registration (`hims` | `hers`). */
  siteId?: "hims" | "hers";
  onAuthChange?: () => void;
};

const HostContext = createContext<CompanionHostContextValue>({});

export function CompanionHostProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: CompanionHostContextValue;
}) {
  return <HostContext.Provider value={value}>{children}</HostContext.Provider>;
}

export function useCompanionHost() {
  return useContext(HostContext);
}

export function useResolvedHostUrl(path: string): string {
  const { hostApiBaseUrl } = useCompanionHost();
  if (!hostApiBaseUrl) return path;
  const base = hostApiBaseUrl.endsWith("/") ? hostApiBaseUrl.slice(0, -1) : hostApiBaseUrl;
  return `${base}${path}`;
}
